import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { AssessmentControlRow, AssessmentControlStatus, AssessmentManagerDetail, AssessmentManagerStatus } from '../../_models/assessmentManager';
import { User } from '../../_models';
import { AssessmentManagerService, UserService } from '../../_services';
import { Role } from '../../helpers';

@Component({
  standalone: false,
  selector: 'assessment-manager-view',
  templateUrl: './assessment-manager-view.component.html',
  styleUrls: ['./assessment-manager-view.component.scss']
})
export class AssessmentManagerViewComponent implements OnInit {
  projectId: number;
  assessmentId: number;
  assessment: AssessmentManagerDetail | null = null;
  assessors: User[] = [];

  controlStatusOptions = [
    { label: 'Active', value: AssessmentControlStatus.Active },
    { label: 'Closed', value: AssessmentControlStatus.Closed }
  ];

  assessmentStatusOptions = [
    { label: 'Active', value: AssessmentManagerStatus.Active },
    { label: 'Closed', value: AssessmentManagerStatus.Closed }
  ];

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private assessmentManagerService: AssessmentManagerService,
    private userService: UserService
  ) {
    this.projectId = +this.route.snapshot.params['projectId'];
    this.assessmentId = +this.route.snapshot.params['assessmentId'];
  }

  ngOnInit() {
    const requests = [
      this.assessmentManagerService.getAssessment(this.projectId, this.assessmentId),
      this.userService.getAllShort()
    ];

    forkJoin(requests).subscribe((data: any[]) => {
      this.assessment = data[0];
      this.assessment.controls.forEach((c) => {
        if (c.dueDate) {
          c.dueDate = new Date(c.dueDate);
        }
      });
      const users: User[] = data[1] || [];
      this.assessors = users.filter(u => (u.role & Role.Assessor) !== 0);
    });
  }

  editAssessment() {
    this.router.navigate(['/projects/project', this.projectId, 'assessments', this.assessmentId, 'edit']);
  }

  backToList() {
    this.router.navigate(['/projects/project', this.projectId, 'assessments']);
  }

  openControl(row: AssessmentControlRow) {
    this.router.navigate(['/projects/project', this.projectId, row.projectControlItemId]);
  }

  saveControl(row: AssessmentControlRow) {
    this.assessmentManagerService.updateAssessmentControl(row.assessmentControlId, {
      assessorUserId: row.assessorUserId,
      dueDate: row.dueDate,
      status: row.status
    }).subscribe();
  }
}
